/* Action Types */
export const SET_SCROLL_POSITION = 'SET_SCROLL_POSITION';

/* Action creators */

export function setScrollPosition(scrollPosition) {
  return {
    type: SET_SCROLL_POSITION,
    scrollPosition,
  }
}



// WEBPACK FOOTER //
// ./src/actions/ui.jsx